import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import PartnerSection from '../../components/PartnerSection';
import ChooseSection from '../../components/ChooseSection/ChooseSection';
import CoinpaySections from '../../components/TokenomicsSection/TokenomicsSection';
import RoadmapSection from '../../components/RoadmapSection/RoadmapSection';
import WhitepaperSection from '../../components/WhitepaperSection/WhitepaperSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';


const HomePage = () => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <Hero />
                    <ChooseSection />
                    <CoinpaySections />
                    <RoadmapSection />
                    <WhitepaperSection />
                    <Scrollbar />
                    <PartnerSection />
                </main>
                <Footer />
            </div>
        </Fragment>
    )
};
export default HomePage;
 